import React, { useState, useEffect } from 'react';
import { Card } from 'antd';
import { useQuery } from '@apollo/client';
import { Link } from 'react-router';

import { queries } from '../../../graphql/graphql';
import { GridImages } from './GridImages';
import { IPlan } from '../../../types/plans';
import { disclaimerStyle } from '../../UI/Disclaimer';

const Recommendation = ({ plan }: { plan: IPlan }) => {
  const { id } = plan;
  const { data = {} } = useQuery(queries.plans.PLAN_RECOMMENDATION, {
    variables: { id },
  });
  const { recommendation } = data;

  const [plans, setPlans] = useState([]);

  useEffect(() => {
    if (recommendation) setPlans(recommendation);
  }, [recommendation]);

  const onRecommendation = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const ListItem = ({ item }: { item: IPlan }) => (
    <Link to={`/plan/${item.id}`} onClick={onRecommendation}>
      <Card
        hoverable={true}
        cover={<img src={item.image} alt="" style={{ aspectRatio: 4 / 3, objectFit: 'cover' }} />}>
        <Card.Meta
          title={
            <span style={{ ...disclaimerStyle, textAlign: 'center' }}>
              {item.title.toUpperCase()}
            </span>
          }
        />
      </Card>
    </Link>
  );

  return <GridImages ListItem={ListItem} items={plans} title="Similar Homes You May Like" />;
};

export default Recommendation;
